import type {
  ExclusionRule,
  InclusionRule,
  SpecialRulesPayload,
} from '@iheartjane/types';
import get from 'lodash-es/get';

import type { SpecialRulesV2 } from '@jane/business-admin/types';

/**
 * Utility to use for React dependency array where we need to keep track of any rule changes (instead of JSON.stringify)
 * @param rules Special rules
 * @returns Consolidated string of rules
 */
export const convertRulesToString = (
  rules?: SpecialRulesPayload | SpecialRulesV2
) => {
  if (!rules) {
    return '';
  }

  const excludes: ExclusionRule = get(rules, 'excludes[0]', {});
  const includes: InclusionRule = get(rules, 'includes[0]', {});

  const compiledRules = [];

  if (rules['product_threshold']) {
    compiledRules.push(Object.values(rules['product_threshold']).join(','));
  }

  compiledRules.push('includes');
  for (const entry of Object.keys(includes) as (keyof InclusionRule)[]) {
    if (entry === 'kinds') {
      includes[entry]?.forEach((kind) => {
        compiledRules.push(Object.values(kind).join(','));
      });
    } else {
      compiledRules.push(Object.values(includes[entry] ?? {}).join(','));
    }
  }

  compiledRules.push('excludes');
  for (const entry of Object.keys(excludes) as (keyof ExclusionRule)[]) {
    if (entry === 'kinds') {
      excludes[entry]?.forEach((kind) => {
        compiledRules.push(Object.values(kind).join(','));
      });
    } else {
      compiledRules.push(Object.values(excludes[entry] ?? {}).join(','));
    }
  }

  return compiledRules.join(':');
};
